import { compressSync, decompressSync, strFromU8, strToU8 } from 'fflate';

export function compress(value: any) {
  return compressSync(strToU8(JSON.stringify(value)));
}

export function decompress(value: any) {
  return JSON.parse(strFromU8(decompressSync(value)));
}
